export const LEGALES_OPTIONS = [
  { value: 'CARTERA CONSUMO' },
  { value: 'CARTERA CONSUMO. \nCFTNA 0,00%.' },
  { value: 'EN COMPRAS PRESENCIAL Y ONLINE. CARTERA DE CONSUMO.' }
];
